{
  "form": {
    "loanAmount": {
      "label": "Required loan amount",
      "error": "Enter the loan amount",
      "placeholder": "euro"
    },
    "maturity": {
      "label": "Maturity",
      "error": "Enter the maturity of the loan",
      "tooltip": "The typical housing loan maturity is 20 to 30 years. You can experiment with different loan maturities to understand their impact on the monthly installments and the total cost of the debt."
    },
    "interestRate": {
      "label": "Interest rate",
      "error": "Enter the total interest rate",
      "tooltip": "The example {{currentInterest}}% interest rate has been calculated on {{date}}. The interest rate on the loan may vary. You can explore different maturities, rates, and repayment methods using our cost calculator."
    },
    "repaymentMethod": {
      "label": "Repayment method",
      "tooltip": {
        "annuity": "An annuity includes both loan amortisation and interest. If interest rates decrease, your payment will be lower, and conversely, if interest rates increase, your payment will be higher. The loan period remains unchanged despite fluctuations in interest rates.",
        "fixedAnnuity": "With a fixed annuity, your monthly payment remains fixed. Changes in interest rates affect the maturity of the loan, extending or shortening the loan period, but your monthly payment remains unchanged. If you choose a fixed annuity, there may be restrictions related to the length of the loan term.",
        "serial": "With equal principal payment, your amortisation stays the same throughout the loan period. The payment amount is calculated by adding the interest to the amortisation. Changes in the interest rate affect the payment amount, but the loan period and amortisation remain unchanged."
      },
      "options": {
        "annuity": "Annuity",
        "fixedAnnuity": "Fixed annuity",
        "serial": "Serial"
      }
    },
    "LoanSecurity": "Loan Insurance",
    "calculateRepaymentSecurity": "Calculate the Loan Insurance to secure the repayment of the loan",
    "securityLevel": {
      "label": "Select the insurance level",
      "tooltip": "Select the portion of the remaining loan amount that the insurance will cover.",
      "options": {
        "low": "50%",
        "medium": "100%",
        "high": "110%"
      }
    },
    "numberOfApplicants": {
      "label": "The number of persons to be insured",
      "error": "Number of applicants required",
      "options": {
        "single": "One to be insured",
        "joint": "Two to be insured"
      }
    },
    "firstBirth": {
      "label": "Age of the main insured person",
      "error": "Please enter the number of days in dd.mm.yyyy"
    },
    "secondBirth": {
      "label": "Age of the second insured person",
      "error": "Please enter the number of days in dd.mm.yyyy"
    },
    "validation": {
      "maturity": {
        "required": "Enter the maturity of the loan",
        "limit": "Enter the maturity in years ({{min}} – {{max}})"
      },
      "interest": {
        "required": "Enter the total interest rate",
        "limit": "Enter the interest rate ({{min}} – {{max}})"
      }
    },
    "submit": "Calculate"
  },
  "results": {
    "heading": "Example calculation of monthly loan costs",
    "subHeading": "Start your loan application early, even if you're still weighing your options. This ensures smooth processing and allows you to receive a preliminary response. It's free and non-binding, with no obligation.",
    "applyForLoanLink": "https://danskebank.fi/lainat/hakemus?lang=en",
    "donutChart": {
      "monthlyInstallment": "Monthly installment",
      "amortization": {
        "label": "Amortisation",
        "tooltip": "Amortisation represents the portion of your loan payment that reduces the principal balance of your loan."
      },
      "interestPayment": {
        "label": "Interest payment"
      },
      "firstInsurancePremium": {
        "label": "First insurance payment"
      },
      "loanAmount": {
        "label": "Loan amount"
      },
      "maturity": {
        "label": "Maturity",
        "tooltip": {
          "text": "The typical housing loan maturity is 20 to 30 years. You can experiment with different loan maturities to understand their impact on the monthly installments and the total cost of the debt using our loan cost calculator.",
          "link": "Go to our loan monthly cost calculator"
        }
      },
      "interestRate": {
        "label": "Interest rate",
        "tooltip": {
          "label": "The interest rate on the loan may rise or fall. You can explore different maturity, rates, and repayment methods with our loan cost calculator.",
          "link": "Go to our loan monthly cost calculator"
        }
      }
    },
    "footer": {
      "label": "You can further explore different maturities, rates, and repayment methods with our loan cost calculator.",
      "ctaButton": "Go to our loan cost calculator"
    }
  },
  "button": {
    "applyForLoan": "Start your loan application"
  },
  "moreInformation": {
    "heading": "More information",
    "howTo": {
      "label": "This is how we have calculated",
      "paragraph1": "The loan information has been calculated based on the entered information. This is not a bank offer. The terms of the loan are agreed upon personally.",
      "paragraph2": "Granting a loan always requires an approved credit decision. In order to make a credit decision, Danske Bank checks the customer's personal credit information from Suomen Asiakastieto Oy. In addition to this, in order to process the credit application, we can retrieve and process your information from the Positive Credit Information Register. The loan interest rate and other conditions are detailed in the loan offer. Request your own offer from Danske Bank.",
      "paragraph3": "The loan protection insurance premium is only an estimate. The amount of the insurance premium is affected by the level of protection and the age of the insured. The insurance premium usually decreases when the amount of the loan decreases. For loan protection, the insured must sign an acceptable health certificate. The loan guarantee is granted by Mandatum Henkivakutus asakehtiö. The insurance premium is not included in the monthly premium calculated here."
    },
    "loanPaymentPlan": {
      "label": "See your loan repayment plan",
      "text": "With monthly installments of {{currentPayment}} €, it will take {{length}} months to repay this loan, and your total costs will be {{totalAmount}} € . Payment plan is calculated at an interest rate of {{interest}} %.",
      "linkText": "View detailed loan repayment plan",
      "modal": {
        "header": "See your loan repayment plan",
        "month": "Month",
        "payment": "Payment",
        "abbreviation": "Abbreviation",
        "interest": "Interest",
        "capital": "Capital"
      }
    },
    "loanSecurityPayment": {
      "label": "Loan Insurance",
      "paragraph1": "The insurance premium for the Loan Insurance is an estimate. A reduction in the loan amount usually reduces the insurance premium. The insurance premium is affected by the amount of loan, insurance coverage and the age of the insured. The insurance premium increases during the term of insurance due to the ageing of the insured.",
      "paragraph2": "Loan Insurance is granted on the basis of a health report submitted in connection with the application.",
      "paragraph3": "Loan Insurance is granted by Mandatum Life Insurance Company Limited (Mandatum) who is responsible for the insurance. Danske Bank acts as an agent for Mandatum. The Finnish Financial Supervisory Authority supervises the insurance agency business in Finland."
    }
  },
  "legalText": {
    "paragraph1": "Example of a home loan: If the customer takes out a home loan of 170,000 euros, where the loan term would be 25 years and the reference interest rate for the loan is the 12-month euribor rate, the total interest rate on the loan would be 4.278% (the effective annual interest rate calculated according to the Consumer Protection Act is 4.452%). The total amount of the credit and other credit costs is 280,765.04 euros, including the arrangement fee of 1,020 euros and the automatic account debit payment of 2.70 euros/payment installment. The number of installments is 300. Example calculated on 25.07.2024 with interest data"
  },
  "tips": {
    "heading": "Need help figuring out how much loan you could get?",
    "subHeading": "First, try our calculator on another page to discover your eligible loan amount.",
    "button": "Calculate how much you could borrow",
    "link": "https://danskebank.fi/en/for-you/products/loans/housing-loan/how-much-loan-can-i-get"
  },
  "years": "years"
}
